import { Tooltip, TooltipContent, TooltipTrigger } from "@loot-os/ui/components/tooltip";

import { formatFullDateTime, formatShortDate } from "../lib/format";

/**
 * A date without its time, for dense table columns; hovering shows the full timestamp. The
 * `<time>` element carries the ISO value so the cell stays machine-readable.
 */
export function ShortDate({ value }: { value: Date | string }) {
  const date = typeof value === "string" ? new Date(value) : value;
  return (
    <Tooltip>
      <TooltipTrigger render={<time dateTime={date.toISOString()} className="cursor-default" />}>
        {formatShortDate(date)}
      </TooltipTrigger>
      <TooltipContent>{formatFullDateTime(date)}</TooltipContent>
    </Tooltip>
  );
}
